// src/components/forms/shared/InputChromeStyles.ts
import { Theme } from '@mui/material/styles';
import { colors } from '../../../theme/theme';

interface InputChromeOptions {
  error?: boolean;
}

// Shared border/shadow recipe used by text inputs, the CustomSelect trigger,
// and the DatePicker wrapper. backgroundColor is intentionally NOT included
// here - it differs by a shade between TextField (grey[0]) and Select/Date
// (grey[50]) and stays local to each component.
export const getInputChromeStyles = (
  theme: Theme,
  options: InputChromeOptions = {}
) => {
  const { error = false } = options;
  const isDark = theme.palette.mode === 'dark';

  return {
    border: `${error ? '4px' : '3px'} solid ${
      error
        ? isDark
          ? theme.palette.error.light
          : theme.palette.error.main
        : theme.palette.primary.main
    }`,
    borderRadius: '0.25rem',
    boxShadow: isDark
      ? 'inset 0 2px 8px rgba(0, 0, 0, 0.6), inset 0 4px 12px rgba(0, 0, 0, 0.4), 0 2px 14px 2px rgba(0, 0, 0, 0.5)'
      : 'inset 0 3px 10px rgba(0, 0, 0, 0.25), inset 0 1px 3px rgba(0, 0, 0, 0.15), 0 2px 6px rgba(0, 0, 0, 0.15)',
  };
};

// Always-on keyboard focus ring (independent of Accessibility Mode), so
// focus is never silently invisible. Layers on top of the base inset
// shadow rather than replacing it, keeping the recessed chrome look.
export const getInputFocusStyles = (theme: Theme, baseBoxShadow: string) => {
  const mode = theme.palette.mode === 'dark' ? 'dark' : 'light';
  const { ringColor, ringWidth } = colors.accessibility.focus;

  return {
    boxShadow: `${baseBoxShadow}, 0 0 0 ${ringWidth} ${ringColor[mode]}`,
  };
};
